export default __webpack_public_path__ + "static/media/audio-mute.dbc8efd7.svg";